import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, Inject, Injector, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { IInputComponent } from '@nimbus-library/features/shared/components/material/i-input-component';

@Component({
  standalone: false,
  selector: 'nimbus-filter-summary-input-mask',
  templateUrl: 'nimbus-filter-summary-input-mask.component.html',
  styleUrls: ['nimbus-filter-summary-input-mask.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: MatFormFieldControl, useExisting: NimbusFilterSummaryInputMaskComponent }],
})
export class NimbusFilterSummaryInputMaskComponent extends IInputComponent<string[]> implements MatFormFieldControl<string[]> {
  public static nextId = 0;

  @Input() public summary: string;
  @Input() public userAriaDescribedBy: string;

  @HostBinding()
  public id = `nimbus-filter-summary-input-mask-${NimbusFilterSummaryInputMaskComponent.nextId++}`;

  public readonly stateChanges = new Subject<void>();
  public readonly controlType = 'nimbus-filter-summary-input-mask';
  public readonly autofilled: boolean = false;
  public readonly focused = false;

  public get empty(): boolean {
    return !this.ngControl.value?.length;
  }

  public get shouldLabelFloat(): boolean {
    return !this.empty || !!this.summary;
  }

  public get errorState(): boolean {
    return this.ngControl && this.ngControl.invalid && (this.ngControl.dirty || this.ngControl.touched);
  }

  public get disabled(): boolean {
    return this.isDisabled;
  }

  public constructor(
    changeDetectionRef: ChangeDetectorRef,
    injector: Injector,
    translateService: TranslateService,
    @Inject(ElementRef) private readonly _elementRef: ElementRef,
  ) {
    super(changeDetectionRef, injector, translateService);
  }

  public setDescribedByIds(ids: string[]): void {
    this._elementRef.nativeElement.setAttribute('aria-describedby', ids.join(' '));
  }

  public onContainerClick(): void {}
}
